import 'animate.css';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import '../../App.css';
import Footer from '../../components/Common/Footer';
import Modal from '../../components/Common/modal/Modal';
import OnTourBar from '../../components/Common/OnTourBar';
import ThankYou from '../../components/Common/ThankYou';
import NavigationBar from '../../components/NavigationBar/NavigationBar';
import { CONFIG } from '../../config/mainConfig';
import { moveToTopPage, setCurrentStoryStep } from '../../helper/helper';
import { IPageDataModel, StoryCreationMethodEnum, StoryLanguageTypeEnum } from '../../interfaces/book.interface';
import { StoryCharacterAgeUnitEnum, StoryCharacterEnum } from '../../interfaces/character.interface';
import { ErrorModulesEnum } from '../../interfaces/error.interface';
import { TeacherOnboardingStatusEnum, UserLocalStorageKeysEnum, UserRoleEnum } from '../../interfaces/user.interface';
import { callAPI } from '../../services/api.service';
import {
  openIsCompleteProfileModalVisible,
  openPlanPurchaseModal,
  openStudentBooksCompletedPopup,
  setBookData,
  setBookId,
  setCurrentStep,
  setDraftId,
  setShowShareModalData,
  setStartNewStory,
} from '../../store/appSlice';
import { AppDispatch, RootState } from '../../store/store';
import { setStoryData, setStoryNewCharacter } from '../../store/storySlice';
import { isAdmin, setShowLogin, setUser } from '../../store/userSlice';
import { getOnboardingData } from '../Teacher/services/Teacher.service';
import { ListViewMode } from './components/ListViewModeSwitcher';
import MainBookControlBar from './components/MainBookControlBar';
import StepCharacterBuilder from './components/StepChacterBuilder/StepCharacterBuilder';
import StepStoryBuilder from './components/StepStoryBuilder';
import StepStoryInformationContainer from './components/StepStoryInformation/StepStoryInformationContainer';
import UserActionSection from './components/UserActionSection';
import { storyExample } from './configs/story-example-configs';
import { CharacterBuilderStateData } from './models/StepCharacterBuilderProps.interface';
import { autosaveStoryDraft, autosaveWithBeacon, collectPagesTextForAutosave } from './services/autosave.service';
import {
  checkSingleBookPlan,
  checkSubscribedToPlan,
  checkUserBookCreationStatus,
  doStartImageGeneration,
  fetchBookData,
  getCharacterImage,
  getCharacterLibary,
  getDraftDetails,
  getLatestError,
  getstoryConfig,
  sortPages,
} from './services/builderHelpers';
import { generatePdf, handleStepThree, startStepSix } from './services/story.service';

const storyPreview = '/avatar-icon.png';

function Builder() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramPlan = searchParams.get('plan');
  const navigateTo = useNavigate();
  const showLogin = useSelector((state: RootState) => state.user.showLogin);
  const user = useSelector((state: RootState) => state.user.user);
  const teacherOnboarding = useSelector((state: RootState) => state.user.teacherOnboarding);
  const draftId = useSelector((state: RootState) => state.app.draftId);
  const currentStep = useSelector((state: RootState) => state.app.currentStep);
  const bookId = useSelector((state: RootState) => state.app.bookId);
  const isTitleModalOpen = useSelector((state: RootState) => state.app.isTitleModalOpen);
  const bookData = useSelector((state: RootState) => state.app.bookData);
  const storyData = useSelector((state: RootState) => state.story.storyData);
  const isCompleteProfileModalVisible = useSelector((state: RootState) => state.app.isCompleteProfileModalVisible);
  const completeProfileModalData = useSelector((state: RootState) => state.app.completeProfileModalData);

  const { newBook } = useParams();
  const [editMode, setEditMode] = useState<string>('no');
  const [selectedBookId, setSelectedBookId] = useState<string | null>(null);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [artStyle, setArtStyle] = useState<string | null>('');
  const [childName, setChildName] = useState<string | null>('');
  const [childAge, setChildAge] = useState<string>('');
  const [wordRange, setWordRange] = useState<any>(null);
  const [storyTopic, setStoryTopic] = useState<string | null>('');
  const [storyType, setStoryType] = useState<string | null>('');
  const [writingStyle, setWritingStyle] = useState<string | null>('');
  const [pageTotal, setPageTotal] = useState<string>('');
  const [selectedArtStyle, setSelectedArtStyle] = useState<string | null>(null);
  const [showStoryForm, setShowStoryForm] = useState<boolean>(false);
  const [storySubStep, setStorySubStep] = useState<string>('setNameStep');
  const [imageGenerationStarted, setImageGenerationStarted] = useState<boolean>(false);
  const imageGenerationStartedRef = useRef<boolean>(false);
  const [imageGenerationFirstCheckAfterCreation, setImageGenerationFirstCheckAfterCreation] = useState<boolean>(false);
  const [bookTitle, setBookTitle] = useState<string | null>('');
  const [storyconfig, setStoryConfig] = useState({});
  const [selectedStoryConfig, setSelectedStoryConfig] = useState<string | null>(null);
  const [maxPages, setMaxpages] = useState<number>(52);
  const [pageOptions, setPageOptions] = useState<string[]>([]);
  const [storyLanguage, setStoryLanguage] = useState<StoryLanguageTypeEnum>(StoryLanguageTypeEnum.ENGLISH);
  const [storyCreationMethod, setStoryCreationMethod] = useState<StoryCreationMethodEnum>(
    StoryCreationMethodEnum.AI_ASSISTED,
  );
  const [planSubscribed, setPlanSubscribed] = useState<boolean>(false);
  const [modalMode, setModalMode] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [uploadedImageUrl, setUploadedImageUrl] = useState<string | null>('');
  const [characterOutlineByUser, setCharacterOutlineByUser] = useState<
    | {
      characterType: string;
      ageUnit: string;
    }[]
    | any
  >({
    characterType: StoryCharacterEnum.human,
    ageUnit: StoryCharacterAgeUnitEnum.year,
    age: '9',
    gender: 'boy',
  });
  const [characterDescription, setCharacterDescription] = useState<string | null>('');
  const [currentPortrait, setCurrentPortrait] = useState<string | null>(null);
  const [customCurrentPortrait, setCustomCurrentPortrait] = useState<string | null>(null);
  const [currentPortraitList, setCurrentPortraitListData] = useState<string[]>([]);
  const setCurrentPortraitList = (value: string[]) => {
    if (customCurrentPortrait && value?.length && !value?.includes(customCurrentPortrait)) {
      setCustomCurrentPortrait(null);
    }
    setCurrentPortraitListData(value);
  };
  const [imageUploading, setImageUploading] = useState<boolean>(false);
  const [showCharacterLibrary, setShowCharacterLibrary] = useState<boolean>(true); //javi
  const [library, setLibrary] = useState<string[]>([]);
  const [showFileInput, setShowFileInput] = useState<boolean>(true);
  const [loader, setLoader] = useState<boolean>(false);
  const [imagesGenerated, setImagesGenerated] = useState<boolean>(false);
  const reportedPageErrorsRef = useRef<Set<string>>(new Set());
  const [loaderImageGeneration, setLoaderImageGeneration] = useState([]);
  const [showBookCover, setShowBookCover] = useState<boolean>(false);
  const [showImageHistory, setShowImageHistory] = useState(null);
  const [showLowCreditModal, setShowLowCreditModal] = useState<boolean>(false);
  const [characterGenerationProgress, setCharacterGenerationProgress] = useState<number>(10);
  const [summaryModal, setSummaryModal] = useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const [imageCharacterPrompt, setimageCharacterPrompt] = useState();
  const [showThanksNote, setShowThanksNote] = useState<boolean>(false);
  const [signUpStep, setSignUpStep] = useState<number>(1);
  const [loaders, setLoaders] = useState({
    characterGenerating: false,
    characterRegenerate: false,
    planExist: false,
  });
  const [stateData, setStateData] = useState<CharacterBuilderStateData>({
    characterId: null,
    showDownloadPDF: true,
    showImageLibrary: false,
    pageIndex: null,
    purchasePlan: false,
  });

  const [mode, setMode] = useState<ListViewMode>(ListViewMode.GRID);
  const [startInterval, setStartInterval] = useState<boolean>(false);

  // useEffect(() => {
  //   if (localStorage.getItem(UserLocalStorageKeysEnum.TOKEN) && !auth.currentUser) {
  //     dispatch(logOut({ user, navigateTo }));
  //   }
  // }, []);

  // State for manual mode pages data (for autosave)
  const [bookStoryPagesData, setBookStoryPagesData] = useState<{ [pageName: string]: IPageDataModel }>({});
  const isTeacherOnboarding = user?.teacherOnboardingStatus === TeacherOnboardingStatusEnum.BookOnboarding;

  const saveTeacherDraftForm = useCallback(() => {
    if (!isTeacherOnboarding || bookId) return;
    try {
      const draft = {
        childName,
        childAge,
        selectedArtStyle,
        storyLanguage,
        storyCreationMethod,
        writingStyle,
        storyType,
        storyTopic,
        pageTotal,
        characterOutlineByUser,
        showStoryForm,
        storySubStep,
      };
      localStorage.setItem(UserLocalStorageKeysEnum.TEACHER_DRAFT_FORM, JSON.stringify(draft));
    } catch {
      /* ignore */
    }
  }, [
    isTeacherOnboarding,
    bookId,
    childName,
    childAge,
    selectedArtStyle,
    storyLanguage,
    storyCreationMethod,
    writingStyle,
    storyType,
    storyTopic,
    pageTotal,
    characterOutlineByUser,
    showStoryForm,
    storySubStep,
  ]);

  const restoreTeacherDraftForm = useCallback(() => {
    try {
      const raw = localStorage.getItem(UserLocalStorageKeysEnum.TEACHER_DRAFT_FORM);
      if (!raw) return false;
      const draft = JSON.parse(raw);
      if (draft.childName) setChildName(draft.childName);
      if (draft.childAge) setChildAge(draft.childAge);
      if (draft.selectedArtStyle) setSelectedArtStyle(draft.selectedArtStyle);
      if (draft.storyLanguage) setStoryLanguage(draft.storyLanguage);
      if (draft.storyCreationMethod) setStoryCreationMethod(draft.storyCreationMethod);
      if (draft.writingStyle) setWritingStyle(draft.writingStyle);
      if (draft.storyType) setStoryType(draft.storyType);
      if (draft.storyTopic) setStoryTopic(draft.storyTopic);
      if (draft.pageTotal) setPageTotal(draft.pageTotal);
      if (draft.characterOutlineByUser) setCharacterOutlineByUser(draft.characterOutlineByUser);
      if (draft.showStoryForm) setShowStoryForm(draft.showStoryForm);
      if (draft.storySubStep) setStorySubStep(draft.storySubStep);
      return true;
    } catch {
      return false;
    }
  }, []);

  // Auto-save functionality
  const lastSavedDataRef = useRef<{
    storyCreationMethod?: StoryCreationMethodEnum;
    storyLanguage?: StoryLanguageTypeEnum;
    writingStyle?: string | null;
    storyType?: string | null;
    storyTopic?: string | null;
  }>({});

  // Keep current values in ref to access during navigation/unmount
  const currentDataRef = useRef<{
    storyCreationMethod: StoryCreationMethodEnum;
    storyLanguage: StoryLanguageTypeEnum;
    writingStyle: string | null;
    storyType: string | null;
    storyTopic: string | null;
    bookId: string | null;
    currentStep: number;
    userEmail: string | null;
    pagesText: { [pageName: string]: IPageDataModel } | null;
  }>({
    storyCreationMethod: StoryCreationMethodEnum.AI_ASSISTED,
    storyLanguage: StoryLanguageTypeEnum.ENGLISH,
    writingStyle: null,
    storyType: null,
    storyTopic: null,
    bookId: null,
    currentStep: 0,
    userEmail: null,
    pagesText: null,
  });

  // Update current data ref whenever values change
  useEffect(() => {
    currentDataRef.current = {
      storyCreationMethod,
      storyLanguage,
      writingStyle,
      storyType,
      storyTopic,
      bookId,
      currentStep,
      userEmail: user?.email || null,
      pagesText: bookStoryPagesData,
    };
  }, [
    storyCreationMethod,
    storyLanguage,
    writingStyle,
    storyType,
    storyTopic,
    bookId,
    currentStep,
    user?.email,
    bookStoryPagesData,
  ]);

  useEffect(() => {
    saveTeacherDraftForm();
  }, [saveTeacherDraftForm]);

  // Auto-save function for page refresh (uses current state values)
  const autoSaveBuilderData = useCallback(async () => {
    if (!bookId || !user?.email) return;

    const currentData = {
      storyCreationMethod,
      storyLanguage,
      writingStyle,
      storyType,
      storyTopic,
    };

    // Check if data has changed since last save
    const lastSaved = lastSavedDataRef.current;
    const hasChanged =
      lastSaved.storyCreationMethod !== currentData.storyCreationMethod ||
      lastSaved.storyLanguage !== currentData.storyLanguage ||
      lastSaved.writingStyle !== currentData.writingStyle ||
      lastSaved.storyType !== currentData.storyType ||
      lastSaved.storyTopic !== currentData.storyTopic ||
      Object.values(bookStoryPagesData || {}).length > 0;

    if (!hasChanged) return;

    const pagesText = bookStoryPagesData ? collectPagesTextForAutosave(bookStoryPagesData) : {};

    const response = await autosaveStoryDraft({
      email: user?.email!,
      bookId,
      step: currentStep,
      storyCreationMethod,
      storyLanguage,
      writingStyle,
      storyType,
      storyTopic,
      pagesText: Object.keys(pagesText).length > 0 ? pagesText : undefined,
    });

    if (response) {
      // Update the last saved data reference
      lastSavedDataRef.current = { ...currentData };
    }
  }, [
    bookId,
    user?.email,
    storyCreationMethod,
    storyLanguage,
    writingStyle,
    storyType,
    storyTopic,
    currentStep,
    bookStoryPagesData,
  ]);

  // Auto-save function for navigation (uses ref values to get latest data)
  const autoSaveBuilderDataFromRef = useCallback(async () => {
    const current = currentDataRef.current;
    if (!current.bookId || !current.userEmail || current.currentStep !== 1) return;

    const currentData = {
      storyCreationMethod: current.storyCreationMethod,
      storyLanguage: current.storyLanguage,
      writingStyle: current.writingStyle,
      storyType: current.storyType,
      storyTopic: current.storyTopic,
      userEmail: current.userEmail,
      step: current.currentStep,
      pagesText: current.pagesText,
    };

    // Check if data has changed since last save
    const lastSaved = lastSavedDataRef.current;
    const hasChanged =
      lastSaved.storyCreationMethod !== currentData.storyCreationMethod ||
      lastSaved.storyLanguage !== currentData.storyLanguage ||
      lastSaved.writingStyle !== currentData.writingStyle ||
      lastSaved.storyType !== currentData.storyType ||
      lastSaved.storyTopic !== currentData.storyTopic ||
      Object.values(current.pagesText || {}).length > 0;

    if (!hasChanged) return;

    const pagesText = current.pagesText ? collectPagesTextForAutosave(current.pagesText) : {};

    const response = await autosaveStoryDraft({
      email: current.userEmail!,
      bookId: current.bookId!,
      step: currentStep,
      storyCreationMethod: current.storyCreationMethod,
      storyLanguage: current.storyLanguage,
      writingStyle: current.writingStyle,
      storyType: current.storyType,
      storyTopic: current.storyTopic,
      pagesText: Object.keys(pagesText).length > 0 ? pagesText : undefined,
    });

    if (response) {
      // Update the last saved data reference
      lastSavedDataRef.current = { ...currentData };
    }
  }, []);

  // Build beacon payload from ref (synchronous, safe during unload/visibility change)
  const buildBeaconPayload = useCallback(() => {
    const current = currentDataRef.current;
    if (!current.bookId || !current.userEmail || current.currentStep !== 1) return null;

    const lastSaved = lastSavedDataRef.current;
    const hasChanged =
      lastSaved.storyCreationMethod !== current.storyCreationMethod ||
      lastSaved.storyLanguage !== current.storyLanguage ||
      lastSaved.writingStyle !== current.writingStyle ||
      lastSaved.storyType !== current.storyType ||
      lastSaved.storyTopic !== current.storyTopic ||
      Object.values(current.pagesText || {}).length > 0;

    if (!hasChanged) return null;

    const pagesText = current.pagesText ? collectPagesTextForAutosave(current.pagesText) : {};

    return {
      email: current.userEmail!,
      bookId: current.bookId!,
      step: current.currentStep,
      storyCreationMethod: current.storyCreationMethod,
      storyLanguage: current.storyLanguage,
      writingStyle: current.writingStyle,
      storyType: current.storyType,
      storyTopic: current.storyTopic,
      pagesText: Object.keys(pagesText).length > 0 ? pagesText : undefined,
    };
  }, []);

  // Handle page refresh/leave — use sendBeacon so the request survives page teardown
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const payload = buildBeaconPayload();
      if (payload) {
        autosaveWithBeacon(payload);
        event.preventDefault();
        event.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [buildBeaconPayload]);

  // Handle visibility change — fires reliably on mobile (lock screen, switch app, close tab)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        const payload = buildBeaconPayload();
        if (payload) {
          autosaveWithBeacon(payload);
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [buildBeaconPayload]);

  // Debounced autosave — triggers 5s after the last data change (step 1 only)
  const debounceTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (!bookId || !user?.email || currentStep !== 1) return;

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      autoSaveBuilderData();
    }, 5000);

    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [
    bookId,
    user?.email,
    currentStep,
    storyCreationMethod,
    storyLanguage,
    writingStyle,
    storyType,
    storyTopic,
    bookStoryPagesData,
    autoSaveBuilderData,
  ]);

  // Save when component unmounts (use ref-based function to get latest values)
  useEffect(() => {
    return () => {
      autoSaveBuilderDataFromRef();
    };
  }, [autoSaveBuilderDataFromRef]); // Only depends on the stable ref-based function

  // Immediate autosave triggered on field blur — cancels the pending debounce timer
  const onBlurAutosave = useCallback(() => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = null;
    }
    autoSaveBuilderData();
  }, [autoSaveBuilderData]);

  const saveCharacterDraft = useCallback(
    (characterOutline: Record<string, any>) => {
      if (!bookId || !user?.email) return;
      autosaveStoryDraft({
        email: user.email,
        bookId,
        step: currentStep,
        characterOutlineByUser: characterOutline,
      });
    },
    [bookId, user?.email, currentStep],
  );

  useEffect(() => {
    console.log('[STEP]: ' + currentStep);
  }, [currentStep]);

  useEffect(() => {
    if (signUpStep === 2) {
      setTimeout(() => dispatch(setUser({ email: user?.email }), 250));
    }
  }, [signUpStep]);

  useEffect(() => {
    if (paramPlan) dispatch(setShowLogin(false));
  }, [paramPlan]);

  useEffect(() => {
    if (currentPortrait && currentPortrait !== CONFIG.CHARACTER.DUMMY_IMAGE && !library?.length) {
      forceUpdateLibrary();
    }
  }, [currentPortrait]);

  useEffect(() => {
    let errorModule = null;
    if (currentStep === 2) errorModule = ErrorModulesEnum.CHARACTER_GENERATION;
    else errorModule = ErrorModulesEnum.IMAGE_GENERATION;

    // Character generation timeout check
    // if (currentStep === 2 && bookData?.deadlineCharacterGenerationAt?.seconds && bookData?.isImageProcessing) {
    //   const deadline = new Date(bookData.deadlineCharacterGenerationAt.seconds * 1000);
    //   const now = new Date();
    //
    //   if (now > deadline) {
    //     stopBookCharacterGeneration(bookId).then().catch()
    //     // Show timeout error
    //     Toast('Character generation timed out. Please try again.', true);
    //     return;
    //   }
    // }

    if ((bookData?.error || +(bookData?.progress || 0) >= 10) && currentStep === 2) {
      // Always call getCharacterImage to process the result and reset loaders.
      // getCharacterImage reads from bookData (already in memory) and resets
      // characterGenerating/characterRegenerate loaders — skipping it would
      // leave the loading spinner stuck indefinitely.
      getCharacterImage(
        bookId,
        setLoaders,
        loaders,
        setCurrentPortrait,
        setCharacterOutlineByUser,
        setCurrentPortraitList,
        setCharacterGenerationProgress,
        setStartInterval,
        bookData,
        storyData,
        errorModule,
        dispatch,
      );
    } else if (currentStep === 3 && storyData?.gettingError === false && isTitleModalOpen === false) {
      // Only call getLatestError when there are NEW page errors (not previously reported)
      if (bookData?.pages) {
        const newErrorPages = Object.keys(bookData.pages).filter(
          (key) => bookData.pages?.[key]?.error === true && !reportedPageErrorsRef.current.has(key),
        );
        if (newErrorPages.length > 0) {
          // Skip if callImageGenerator just handled an error (within last 5 seconds)
          const recentlyHandled = storyData?.lastHandledErrorAt && Date.now() - storyData.lastHandledErrorAt < 5000;
          // Skip toast when the per-page UI already fully explains the
          // failure: moderation (amber banner + guidance) and Runware
          // credits exhaustion (red tile + editor banner with support
          // email). For both cases the toast is redundant noise.
          const allHandledByTile = newErrorPages.every(
            (key) =>
              !!bookData.pages?.[key]?.contentFilter?.flagged ||
              bookData.pages?.[key]?.errorCategory === 'config-insufficient-credits',
          );
          if (!recentlyHandled && !allHandledByTile) {
            newErrorPages.forEach((key) => reportedPageErrorsRef.current.add(key));
            getLatestError(bookData?.bookId!, errorModule, dispatch);
          } else {
            // Still mark as reported so we don't re-trigger
            newErrorPages.forEach((key) => reportedPageErrorsRef.current.add(key));
          }
        }
      }

      if (
        bookData?.pages &&
        Object.keys(bookData.pages).length &&
        Object.keys(bookData.pages).some(
          (pageKey) => bookData.pages && bookData.pages[pageKey]?.text && bookData.pages[pageKey]?.scene,
        ) &&
        !imageGenerationFirstCheckAfterCreation
      ) {
        setImageGenerationFirstCheckAfterCreation(true);
        displayBookPages();
        // Clear storybuildingError only when pages are confirmed valid
        if (storyData?.storybuildingError) {
          dispatch(setStoryData({ ...storyData, storybuildingError: false }));
        }
      }
    }

    if (bookData && bookData.bookId && !selectedStoryConfig && bookData.childAge) {
      setSelectedStoryConfig(bookData.childAge);
    }
  }, [currentStep, bookData]);

  useEffect(() => {
    if (showCharacterLibrary) getCharacterLibary(user?.email!, loaders, setLoaders, setLibrary);
  }, [showCharacterLibrary, user?.email]);
  const [showDescription, setShowDescription] = useState(false);

  const resetCharacter = () => {
    setSelectedImage(null);
    setCurrentPortrait(null);
    setCurrentPortraitList([]);
    setimageCharacterPrompt(undefined);
    setShowCharacterLibrary(false);
    dispatch(setStoryNewCharacter(true));
    dispatch(
      setStoryData({
        ...storyData,
        showLibrary: false,
      }),
    );
  };

  const resetStory = () => {
    localStorage.removeItem(UserLocalStorageKeysEnum.BOOK_ID);
    localStorage.removeItem(UserLocalStorageKeysEnum.EDIT_MODE);
    localStorage.removeItem(UserLocalStorageKeysEnum.TEACHER_DRAFT_FORM);
    setSelectedImage(null);
    dispatch(setDraftId(null));
    dispatch(setBookId(null));
    setUploadedImageUrl('');
    setCharacterDescription('');
    setBookTitle('');
    dispatch(setBookData(null));
    setChildName('');
    setChildAge('');
    setStoryTopic('');
    setStoryType('');
    setPageTotal('');
    setWritingStyle('');
    setArtStyle('');
    setStoryLanguage(StoryLanguageTypeEnum.ENGLISH);
    setStoryCreationMethod(StoryCreationMethodEnum.AI_ASSISTED);
    setWordRange(null);
    dispatch(setCurrentStep(0));
    setShowStoryForm(false);
    dispatch(setStartNewStory(true));
    setSelectedArtStyle(null);
    if (isTeacherOnboarding) {
      setCharacterOutlineByUser({
        characterType: StoryCharacterEnum.human,
        ageUnit: StoryCharacterAgeUnitEnum.year,
        age: '9',
        gender: 'boy',
      });
      setChildAge('');
    } else {
      setCharacterOutlineByUser({ characterType: StoryCharacterEnum.human, ageUnit: StoryCharacterAgeUnitEnum.year });
    }
    setCurrentPortrait(null);
    setCurrentPortraitList([]);
  };

  const runGetDraftDetails = (overrideBookId?: string) => {
    getDraftDetails(
      overrideBookId || draftId! || bookId!,
      dispatch,
      dispatch,
      setShowStoryForm,
      setUploadedImageUrl,
      setCharacterDescription,
      setBookTitle,
      setStoryType,
      setChildName,
      (value) => setChildAge(value?.toString()),
      setMaxpages,
      (value) => setPageTotal(value?.toString()),
      setWritingStyle,
      setSelectedArtStyle,
      setStoryLanguage,
      setWordRange,
      setCurrentPortrait,
      setCurrentPortraitList,
      setCharacterOutlineByUser,
      setSelectedImage,
      setSelectedStoryConfig,
      dispatch,
      dispatch,
      storyconfig,
      setStoryTopic,
      setCurrentStoryStep,
      dispatch,
      setStoryCreationMethod,
      setBookStoryPagesData,
    );
  };

  useEffect(() => {
    // when user hit create New Book, then clear every thing
    if (newBook) resetStory();
  }, [newBook]);

  useEffect(() => {
    if (bookId && currentStep === 2) {
      forceUpdateLibrary();
    }
  }, [bookId, currentStep]);

  useEffect(() => {
    const isEditMode = localStorage.getItem(UserLocalStorageKeysEnum.EDIT_MODE);
    setEditMode(isEditMode ? isEditMode : 'no');
    let bookId = localStorage.getItem(UserLocalStorageKeysEnum.BOOK_ID);
    if (draftId || isEditMode === 'yes') {
      runGetDraftDetails();
      if (draftId || bookId) {
        setSelectedBookId(draftId || bookId);
        localStorage.setItem(UserLocalStorageKeysEnum.BOOK_ID, draftId! || bookId!);
        localStorage.setItem(UserLocalStorageKeysEnum.EDIT_MODE, 'yes');
        setEditMode('yes');
      }
    } else {
      if (user?.email && bookId) {
        setSelectedBookId(bookId);
        runGetDraftDetails();
      } else {
        dispatch(setCurrentStep(0));
        localStorage.removeItem(UserLocalStorageKeysEnum.BOOK_ID);
      }
    }

    return () => {
      setImageGenerationFirstCheckAfterCreation(false);
    };
  }, []);

  useEffect(() => {
    if (user?.isTeacherMode && !teacherOnboarding) {
      getOnboardingData(dispatch);
    }
  }, [user?.isTeacherMode]);

  const [teacherRecoveryDone, setTeacherRecoveryDone] = useState(false);
  const teacherRecoveryStarted = useRef(false);
  useEffect(() => {
    if (teacherRecoveryDone || teacherRecoveryStarted.current) return;
    if (!isTeacherOnboarding || !user?.email) return;
    const localBookId = localStorage.getItem(UserLocalStorageKeysEnum.BOOK_ID);
    if (localBookId) {
      setTeacherRecoveryDone(true);
      return;
    }

    teacherRecoveryStarted.current = true;
    callAPI(`api/booklist?email=${user.email}&archived=no`)
      .then((res) => {
        const lastBook = res?.books?.[0];
        if (lastBook?.bookId) {
          localStorage.setItem(UserLocalStorageKeysEnum.BOOK_ID, lastBook.bookId);
          localStorage.setItem(UserLocalStorageKeysEnum.EDIT_MODE, 'yes');
          setSelectedBookId(lastBook.bookId);
          setEditMode('yes');
          runGetDraftDetails(lastBook.bookId);
        } else {
          restoreTeacherDraftForm();
          dispatch(setCurrentStep(0));
        }
      })
      .catch(() => {
        restoreTeacherDraftForm();
        dispatch(setCurrentStep(0));
      })
      .finally(() => {
        setTeacherRecoveryDone(true);
      });
  }, [user, teacherOnboarding]);

  useEffect(() => {
    if (bookId) {
      const storyStep = localStorage.getItem(UserLocalStorageKeysEnum.STORY_STEP);
      if (storyStep) {
        switch (storyStep) {
          case CONFIG.STORY_STEPS.BASIC_INFO:
            break;
          case CONFIG.STORY_STEPS.CHARACTER_BUILD:
            dispatch(setCurrentStep(2));
            break;
          case CONFIG.STORY_STEPS.ILLUSTRATION_CREATE:
            dispatch(setCurrentStep(3));
            break;
          case CONFIG.STORY_STEPS.PURCHASE_DOWNLOAD:
            dispatch(setCurrentStep(6));
            break;
        }
      } else localStorage.removeItem(UserLocalStorageKeysEnum.STORY_STEP);
    }
  }, [bookId, localStorage.getItem(UserLocalStorageKeysEnum.STORY_STEP)]);

  useEffect(() => {
    if (!localStorage.getItem(UserLocalStorageKeysEnum.BOOK_ID)) resetStory();
  }, [localStorage.getItem(UserLocalStorageKeysEnum.BOOK_ID)]);
  // *************************************** STEP ONE - STORY SUBMISSION ***************************************
  useEffect(() => {
    if (uploadedImageUrl) dispatch(setStoryData({ ...storyData, uploadedImage: uploadedImageUrl }));
  }, [uploadedImageUrl]);

  const startStepOne = async (setLoader?: any, validate?: boolean) => {
    if (!user) {
      return;
    }
    const allowBookCreation = await checkUserBookCreationStatus(user?.email!);
    if (allowBookCreation) {
      dispatch(setCurrentStep(1));
      setCurrentStoryStep(CONFIG.STORY_STEPS.BASIC_INFO);
      setShowStoryForm(true);
      if (storyData && bookId === storyData?.bookId) {
        setChildName(storyData?.childName || '');
        setChildAge(storyData?.childAge || '');
        setStoryTopic(storyData?.storyTopic || '');
        setStoryType(storyData?.storyType || '');
        setWritingStyle(storyData?.writingStyle || '');
        setPageTotal(storyData?.pageTotal || '');
        setSelectedArtStyle(storyData?.artStyle || null);
        setStoryLanguage(storyData?.storyLanguage || StoryLanguageTypeEnum.ENGLISH);
        setStoryCreationMethod(storyData?.storyCreationMethod || StoryCreationMethodEnum.AI_ASSISTED);
        setSelectedStoryConfig(storyData?.childAge || null);
      }
    } else {
      if (validate) {
        if (user?.role === UserRoleEnum.student) {
          dispatch(openStudentBooksCompletedPopup({ show: true }));
        } else {
          dispatch(
            openPlanPurchaseModal({
              show: true,
              data: {
                title: 'Upgrade Plan!',
                description:
                  "Order a physical copy of the book you're creating, or subscribe to a limited-time free trial to finish your current story and start new ones!",
              },
            }),
          );
        }
      }
      if (setLoader) setLoader(false);
    }
  };
  const [previewImage, setPreviewImage] = useState(null);
  const startStepTwo = () => {
    dispatch(setCurrentStep(2));
  };
  // ***************************************  STEP THREE - STORY CREATION ***************************************
  const setLoadingStatus = (page: string, isLoading: boolean) => {
    setLoaderImageGeneration((prevLoader) => ({ ...prevLoader, [page]: isLoading }));
  };

  useEffect(() => {
    if (currentStep === 3) {
      // Skip full book regeneration when user is just changing a single page's character.
      // Check pageIndex specifically — a truthy illustrationCharacter without pageIndex
      // is an artifact from handleSubmitStepTwo, not an actual page-level edit.
      if (storyData?.illustrationCharacter?.pageIndex) return;

      // Don't re-call api/magic if pages already have text and scene (prevents reload loop)
      const pagesAlreadyGenerated =
        bookData?.pages &&
        Object.keys(bookData.pages).length > 0 &&
        Object.values(bookData.pages).every((page) => page?.text && page?.scene);
      // Don't auto-retry if there was an error — let user click Retry
      if (!pagesAlreadyGenerated && !storyData?.storybuildingError) {
        executeStepThree();
      }
    }
  }, [currentStep, characterDescription, uploadedImageUrl]);

  const executeStepThree = async () => {
    await handleStepThree(
      bookId!,
      stateData,
      customCurrentPortrait || currentPortrait!,
      dispatch,
      setStoryData,
      setCurrentStoryStep,
      setCurrentStep,
      setBookTitle,
      storyData,
    );
  };

  const [modalOpen, setModalOpen] = useState(false);

  // ***************************************
  // STEP FOUR - IMAGE GENERATION
  // ***************************************
  useEffect(() => {
    if (currentStep >= 3) {
      displayBookPages();
      const interval = setInterval(() => {
        if (modalOpen === false && imagesGenerated === false && isTitleModalOpen === false) displayBookPages();
      }, 10000); // Polling every 10 seconds
      return () => clearInterval(interval);
    }
  }, [currentStep, bookId, modalOpen, imageGenerationStarted, imagesGenerated]);

  // Reactively update imagesGenerated when bookData.pages changes (e.g. from sortPages dispatch)
  useEffect(() => {
    if (bookData?.pages && Object.keys(bookData.pages).length > 0) {
      const allDone = Object.values(bookData.pages).every(
        (page: any) => !!page?.imageURL || !!page?.error,
      );
      if (allDone !== imagesGenerated) {
        setImagesGenerated(allDone);
      }
    }
  }, [bookData?.pages]);

  useEffect(() => {
    moveToTopPage();
  }, [currentStep]);

  const startImageGeneration = async () => {
    let bookDetails = await fetchBookData(localStorage.getItem('bookId')!);
    const freeMode = user?.isTrialFreeAccess === true || user?.plan?.name === CONFIG.PROMO_PLAN;
    const showErrorMsg = !(freeMode && bookDetails?.creditsPerBookLimit === 0);
    const status = await doStartImageGeneration(bookId!, showErrorMsg);
    if (status === -1) {
      if (user?.plan?.name === CONFIG.PROMO_PLAN) {
        setStateData((prevData) => ({
          ...prevData,
          purchasePlan: true,
        }));
      }
    }
  };

  const displayBookPages = async () => {
    const fetchedBookData = await fetchBookData(bookId!);
    if (fetchedBookData && fetchedBookData.pages) {
      sortPages(fetchedBookData, dispatch);
      let allImagesGenerated = true;
      fetchedBookData &&
        Object.entries(fetchedBookData.pages).map((page: any) => {
          if (!page[1]?.imageURL && !page[1]?.error) allImagesGenerated = false;
        });

      setImagesGenerated(allImagesGenerated);

      if (
        !allImagesGenerated &&
        imageGenerationStartedRef.current === false &&
        bookId &&
        fetchedBookData?.pages &&
        Object.values(fetchedBookData.pages).every((page: any) => page?.text && page?.scene)
      ) {
        imageGenerationStartedRef.current = true;
        setImageGenerationStarted(true);
        startImageGeneration();
      }
      if (allImagesGenerated) {
        imageGenerationStartedRef.current = false;
        setImageGenerationStarted(false);
      }
    }
  };

  // *************************************** STEP FIVE - APPROVE COVER ***************************************
  const [selectedCoverUrl, setSelectedCoverUrl] = useState(null);
  const handleStartStepSix = async () => {
    await startStepSix(bookId!, selectedCoverUrl, bookData, dispatch, setCurrentStep, setCurrentStoryStep);
  };

  useEffect(() => {
    getstoryConfig(setStoryConfig, dispatch);
    if (user) {
      if (localStorage.getItem(UserLocalStorageKeysEnum.STORY_STEP) === CONFIG.STORY_STEPS.BASIC_INFO) startStepOne();
    }
  }, []);

  useEffect(() => {
    if (user) {
      checkSubscribedToPlan(user, setLoaders, setPlanSubscribed, loaders, navigateTo, dispatch);
      // if (localStorage.getItem(UserLocalStorageKeysEnum.STORY_STEP) === CONFIG.STORY_STEPS.BASIC_INFO) startStepOne();
      checkSingleBookPlan(user?.planRef?._path?.segments[1], dispatch);
    }
  }, [user]);

  useEffect(() => {
    setPageOptions([]);
    let newOptions: any = [];
    for (let i = 16; i <= maxPages; i = i + 4) {
      newOptions.push(
        <option key={i} value={i}>
          {i}
        </option>,
      );
    }
    setPageOptions(newOptions);
  }, [maxPages]);

  const handleGeneratePdf = async () => {
    await generatePdf(bookId!, setLoader, setPdfUrl);
  };

  if (isAdmin()) {
    return <Navigate to="/admin/dashboard" />;
  }

  const goBack = () => {
    navigateTo(-1);
    setShowThanksNote(false);
  };

  const forceUpdateLibrary = () => {
    getCharacterLibary(user?.email!, loaders, setLoaders, setLibrary);
  };

  const getOnTourStep = (): {
    step: number;
    total: number;
    title: string;
    description: string;
    buttonText?: string;
  } => {
    if (currentStep === 1 && storySubStep === 'setNameStep') {
      return {
        step: 1,
        total: 5,
        title: 'Name your character',
        description: 'Pick a name, page length, and art style to get started.',
      };
    }
    if (currentStep === 1 && storySubStep === 'setStoryDataStep') {
      return {
        step: 2,
        total: 5,
        title: 'Story details',
        description:
          'This is where the story comes together. Page by page, they build something they cannot wait to see illustrated.',
      };
    }
    if (currentStep === 2) {
      const hasGeneratedCharacter = !!(
        bookData?.characterPortrait && bookData.characterPortrait !== CONFIG.CHARACTER.DUMMY_IMAGE
      );
      return {
        step: 3,
        total: 5,
        title: 'Design your character',
        description: 'Describe and generate your main character illustration',
        buttonText: hasGeneratedCharacter ? 'Continue' : 'Generate!',
      };
    }
    if (currentStep >= 3) {
      return {
        step: 4,
        total: 5,
        title: 'Review your book',
        description: 'Check your pages, edit text and generate images',
        buttonText: imagesGenerated ? 'Continue' : 'Generating...',
      };
    }
    return { step: 1, total: 5, title: 'Create your first book', description: 'Follow the steps to build a story' };
  };

  const onTourStep = getOnTourStep();

  return (
    <div className="App mx-auto">
      {isTeacherOnboarding && currentStep >= 1 && !(currentStep < 3 && storyData?.illustrationCharacter?.pageIndex) ? (
        <OnTourBar
          stepNumber={onTourStep.step}
          totalSteps={onTourStep.total}
          title={onTourStep.title}
          description={onTourStep.description}
          buttonText={onTourStep.buttonText}
          showButton={true}
          onButtonClick={() => {
            if (currentStep === 2) {
              const hasGeneratedCharacter = !!(
                bookData?.characterPortrait && bookData.characterPortrait !== CONFIG.CHARACTER.DUMMY_IMAGE
              );
              if (!hasGeneratedCharacter) {
                const btn = document.getElementById('step-generate-button');
                if (btn) btn.click();
                return;
              }
            }
            if (currentStep >= 3 && !imagesGenerated) {
              return;
            }
            if (currentStep >= 3 && imagesGenerated) {
              navigateTo(`/bookflip/${bookId}?mode=preview`);
              return;
            }
            const btn = document.getElementById('step-next-button');
            if (btn) btn.click();
          }}
          showBackButton={(currentStep > 1 && currentStep < 3) || (currentStep === 1 && storySubStep !== 'setNameStep') || (currentStep >= 3 && !!storyData?.storybuildingError)}
          onBackClick={() => {
            if (currentStep >= 3 && storyData?.storybuildingError) {
              dispatch(setStoryData({ ...storyData, storybuildingError: false }));
              setCurrentStoryStep(CONFIG.STORY_STEPS.CHARACTER_BUILD);
              dispatch(setCurrentStep(2));
              return;
            }
            // Step 2 → go back to step 1 "story details" sub-step (not the first sub-step)
            if (currentStep === 2) {
              setCurrentStoryStep(CONFIG.STORY_STEPS.BASIC_INFO);
              setStorySubStep('setStoryDataStep');
              dispatch(setCurrentStep(1));
              return;
            }
            // Step 1 sub-step navigation — set sub-step directly instead of DOM click
            setStorySubStep('setNameStep');
          }}
        />
      ) : (
        <NavigationBar
          hideActions={
            isTeacherOnboarding ||
            (!user?.isTeacherMode && ((currentStep === 1 && storySubStep !== 'setNameStep') || currentStep === 2))
          }
        />
      )}
      {currentStep >= 3 && !isTeacherOnboarding && (
        <MainBookControlBar
          showListModeSwitcher={true}
          mode={mode}
          setMode={setMode}
          onShare={() => dispatch(setShowShareModalData(bookData))}
          bookData={bookData}
          mainButtonDisabled={!imagesGenerated}
          user={user}
          isTeacherOnboarding={false}
        />
      )}
      {stateData.purchasePlan === true && (
        <Modal
          title="Plan Purchase"
          description="Please choose a plan to complete your book or finish this book for free in slow mode."
          doProcess={() => navigateTo('/myPlans')}
          submitButtonTitle="Subscribe to Plan"
          showCloseButton={false}
          showPromoFreeBook={true}
          setImageGenerationStarted={(v: boolean) => { imageGenerationStartedRef.current = v; setImageGenerationStarted(v); }}
        />
      )}
      {showThanksNote ? (
        <ThankYou goBack={goBack} />
      ) : (
        <div className="flex bg-storytan  p-0 md:p-4 mx-auto min-h-[70vh]">
          {/*{showStoryForm && !showBookCover && currentStep === 3 && <ToolBar setMode={setMode} />}*/}
          <div className="w-[100vw] md:max-w-7xl mx-auto">
            {!showStoryForm &&
              currentStep === 0 &&
              (isTeacherOnboarding && !teacherRecoveryDone ? (
                <div className="min-h-[50vh] flex items-center justify-center">
                  <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-secondaryStoryLightBlueText"></div>
                </div>
              ) : (
                <UserActionSection
                  user={user}
                  planSubscribed={planSubscribed}
                  loaders={loaders}
                  showLogin={showLogin}
                  signUpStep={signUpStep}
                  setSignUpStep={setSignUpStep}
                  paramPlan={paramPlan!}
                  startStepOne={(loader) => startStepOne(loader, true)}
                  setLoaders={setLoaders}
                  setShowThanksNote={setShowThanksNote}
                  setPlanSubscribed={setPlanSubscribed}
                />
              ))}
            {showStoryForm && currentStep == 1 && (
              <StepStoryInformationContainer
                setSelectedBookId={setSelectedBookId}
                setLoader={setLoader}
                setShowLowCreditModal={setShowLowCreditModal}
                setSelectedStoryConfig={setSelectedStoryConfig}
                setMaxpages={setMaxpages}
                setShowDescription={setShowDescription}
                setStoryTopic={setStoryTopic}
                setStoryType={setStoryType}
                setChildName={setChildName}
                setArtStyle={setArtStyle}
                setChildAge={setChildAge}
                setPageTotal={setPageTotal}
                setWritingStyle={setWritingStyle}
                setStoryCreationMethod={setStoryCreationMethod}
                bookId={bookId!}
                currentStep={currentStep}
                childName={childName!}
                childAge={childAge}
                storyTopic={storyTopic!}
                storyType={storyType!}
                writingStyle={writingStyle!}
                pageTotal={pageTotal}
                artStyle={artStyle}
                storyconfig={storyconfig}
                storyExample={storyExample}
                selectedStoryConfig={selectedStoryConfig!}
                wordRange={wordRange!}
                startStepTwo={startStepTwo}
                pageOptions={pageOptions}
                loader={loader}
                showLowCreditModal={showLowCreditModal}
                showDescription={showDescription}
                storyLanguage={storyLanguage}
                setStoryLanguage={setStoryLanguage}
                selectedArtStyle={selectedArtStyle}
                setSelectedArtStyle={setSelectedArtStyle}
                storyData={storyData}
                storyCreationMethod={storyCreationMethod}
                bookStoryPagesData={bookStoryPagesData}
                setBookStoryPagesData={setBookStoryPagesData}
                onBlurAutosave={onBlurAutosave}
                onSubStepChange={setStorySubStep}
                initialSubStep={storySubStep}
              />
            )}
            {showStoryForm && currentStep === 2 && (
              <StepCharacterBuilder
                setStateData={setStateData}
                setLibrary={setLibrary}
                setStartInterval={setStartInterval}
                setImageUploading={setImageUploading}
                setCharacterDescription={setCharacterDescription}
                setLoaders={setLoaders}
                setCharacterOutlineByUser={setCharacterOutlineByUser}
                setSelectedImage={setSelectedImage}
                setUploadedImageUrl={setUploadedImageUrl}
                setCurrentPortraitList={setCurrentPortraitList}
                setCurrentPortrait={setCurrentPortrait}
                setCustomCurrentPortrait={setCustomCurrentPortrait}
                setPreviewImage={setPreviewImage}
                setShowCharacterLibrary={setShowCharacterLibrary}
                showCharacterLibrary={showCharacterLibrary}
                library={library}
                forceUpdateLibrary={forceUpdateLibrary}
                loaders={loaders}
                currentStep={currentStep}
                imageUploading={imageUploading}
                draftId={draftId!}
                resetStory={resetStory}
                selectedImage={selectedImage}
                currentPortrait={customCurrentPortrait || currentPortrait!}
                showFileInput={showFileInput}
                characterGenerationProgress={characterGenerationProgress}
                setCharacterGenerationProgress={setCharacterGenerationProgress}
                uploadedImageUrl={uploadedImageUrl!}
                currentPortraitList={currentPortraitList}
                previewImage={previewImage!}
                storyPreview={storyPreview}
                characterOutlineByUser={characterOutlineByUser}
                bookId={bookId!}
                artStyle={artStyle!}
                stateData={stateData}
                getCharacterLibary={getCharacterLibary}
                imageCharacterPrompt={imageCharacterPrompt!}
                setimageCharacterPrompt={setimageCharacterPrompt}
                resetCharacter={resetCharacter}
                selectedArtStyle={selectedArtStyle}
                setSelectedArtStyle={setSelectedArtStyle}
                onSaveCharacterDraft={saveCharacterDraft}
              />
            )}

            {showStoryForm && currentStep >= 3 && (
              <StepStoryBuilder
                setLoadingStatus={setLoadingStatus}
                setStateData={setStateData}
                setShowImageHistory={setShowImageHistory}
                setShowLowCreditModal={setShowLowCreditModal}
                setBookTitle={setBookTitle}
                setMode={setMode}
                setModalOpen={setModalOpen}
                setModalMode={setModalMode}
                setShowBookCover={setShowBookCover}
                setSelectedCoverUrl={setSelectedCoverUrl}
                showLowCreditModal={showLowCreditModal}
                closeLowCreditModal={() => setShowLowCreditModal(false)}
                showImageHistory={showImageHistory}
                showBookCover={showBookCover}
                showStoryForm={showStoryForm}
                stateData={stateData}
                bookId={bookId}
                bookData={bookData!}
                bookTitle={bookTitle!}
                imagesGenerated={imagesGenerated}
                selectedCoverUrl={selectedCoverUrl!}
                loader={loader}
                loaderImageGeneration={loaderImageGeneration}
                startStepSix={handleStartStepSix}
                currentStep={currentStep}
                draftId={draftId!}
                mode={mode}
                modalMode={modalMode!}
                modalOpen={modalOpen}
                resetStory={resetStory}
                displayBookPages={displayBookPages}
                summaryModal={summaryModal}
                setSummaryModal={setSummaryModal}
                setShowStoryForm={setShowStoryForm}
                setimageCharacterPrompt={setimageCharacterPrompt}
                imageCharacterPrompt={imageCharacterPrompt!}
                setShowCharacterLibrary={setShowCharacterLibrary}
                onRetryPageGeneration={() => {
                  dispatch(setStoryData({ ...storyData, storybuildingError: false }));
                  executeStepThree();
                }}
                onGoBackToCharacter={() => {
                  dispatch(setStoryData({ ...storyData, storybuildingError: false }));
                  setCurrentStoryStep(CONFIG.STORY_STEPS.CHARACTER_BUILD);
                  dispatch(setCurrentStep(2));
                }}
              />
            )}
            {/*{currentStep === 6 && (*/}
            {/*  <StepPDFDownloadPurchase*/}
            {/*    bookId={bookId!}*/}
            {/*    stateData={stateData}*/}
            {/*    pdfUrl={pdfUrl!}*/}
            {/*    generatePdf={handleGeneratePdf}*/}
            {/*    selectedBookId={selectedBookId!}*/}
            {/*    bookData={bookData!}*/}
            {/*    loader={loader}*/}
            {/*  />*/}
            {/*)}*/}
          </div>
        </div>
      )}
      {isCompleteProfileModalVisible && (
        <Modal
          title={completeProfileModalData?.title}
          description={completeProfileModalData?.description}
          className={'global-absolute-popup-style secondary-alert'}
          showSubmitButton={false}
          showCloseButton={false}
          showTopRightCloseButton={false}
        >
          <div className="flex w-full justify-center items-center mt-3">
            <button
              onClick={() => {
                navigateTo('/updateProfile');
                dispatch(openIsCompleteProfileModalVisible({ show: false }));
              }}
              className="bg-storyblueSecondLightText text-white font-semibold py-2 px-6 rounded-full transition-all"
            >
              Continue
            </button>
          </div>
        </Modal>
      )}
      <Footer className="mb-0 pb-4" />
    </div>
  );
}

export default Builder;
